import { Navigate } from 'react-router';

import { useUser } from '#/contexts/UserEnvironmentContext';
import { useSetDocumentTitle } from '#/hooks/useSetDocumentTitle';
import { useTrackPageView } from '#/hooks/useTrackPageView';
import { useI18n } from '#/i18n/hooks/useI18n';
import { Layout } from '#/layouts/Layout/Layout';
import { PostAListingPage } from '#/pages/PostAListing/PostAListingPage';

export function UserDashboardPostAListingPage() {
  const { i18n } = useI18n();

  const { user } = useUser();
  const orgs = user?.orgs ?? [];

  useSetDocumentTitle(i18n('Post A Listing'));

  useTrackPageView('User Dashboard - Post A Listing', {
    page_type: 'User Dashboard',
  });

  if (orgs.length === 1) {
    const [org] = orgs;

    if (org.isAllowedToPost && !org.isFrozen) {
      return <Navigate to={`/admin/${org.id}/post-a-listing`} replace />;
    }

    return <Navigate to={`/admin/${org.id}`} replace />;
  }

  return (
    <Layout variant="base" darkBackground>
      <PostAListingPage orgs={orgs} />
    </Layout>
  );
}
